import { Header } from './Header';

export const ComponentStrings = {
  ...Header,
};
